import * as THREE from 'three';

export class RoachManager {
    constructor({ model, scene, count }) {
        this.roachesCount = count;

        // Start with one guy
        this.roaches = [model.scene.getObjectByName("roach")];

        for (let i = 1; i < this.roachesCount; i++) {
            const newRoach = this.roaches[0].clone();
            this.roaches.push(newRoach);
            scene.add(newRoach);
        }

        // Give all a custom lastPosition prop
        this.roaches.forEach(r => r.lastPosition = new THREE.Vector2());
    }

    update(time) {
        this.roaches.forEach((roach, i) => {
            const newX = Math.sin(time * (0.126 + i * 0.03) + i * 2.142 + Math.cos(time * 1.521 + i * 1.45) * 0.1) * (20 + Math.sin(time * 4.12 + i * 1.13) * 5);
            const newZ = Math.cos(time * (0.223 + i * 0.03) + i * 1.123 + Math.cos(time * 1.345 + i * 1.21) * 0.15) * (20 + Math.sin(time * 4.52 + i * 1.32) * 3);

            const { x, z } = roach.lastPosition;
            const dx = newX - x;
            const dz = newX - z;
            roach.position.set(newX, 0.2, newZ);
            roach.rotation.y = Math.atan2(-dz, dx);

            roach.lastPosition.x = newX;
            roach.lastPosition.z = newZ;
        });
    }
}